import _ from 'lodash';
//import async from 'async';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import QueuedVendorBillContainer from '../../containers/billing/QueuedVendorBills';
import AuthUserContainer from '../../containers/AuthUser';

//- UI / Form
import FormComponent from '../../components/FormComponent';
import FMPRegionHeader from '../../components/ui/FMPRegionHeader';
import { vendorStyles } from './vendorBillShared';

const styles = (theme) => {
	return {
		...vendorStyles(theme),

		poInfo: {
			marginTop: '5%',
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
		},
		poGroup: {
			flexGrow: 1,
			marginRight: '6%',
			marginTop: '5%',
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
		},
		poLabel: {
			fontWeight: 500,
			color: '#666',
			textTransform: 'uppercase',
			marginRight: '10px',
			textAlign: 'right',
			fontSize: '80%',
		},
	};
};

class QueuedVendorBillView extends FormComponent {
	constructor(props) {
		super(props);
		const queuedVendorBillId = _.get(this.props, ['match', 'params', 'queuedVendorBillId']);

		this.state = {
			queuedVendorBillId: queuedVendorBillId ? parseInt(queuedVendorBillId, 10) : undefined,
			formFieldError: {},
			invoiceDocuments: [],
			isAttemptingMatch: false,
		};
	}

	componentDidMount() {
		const { queuedVendorBill, getQueuedVendorBill } = this.props;

		const { queuedVendorBillId } = this.state;

		if (!queuedVendorBill) {
			getQueuedVendorBill({
				params: { queuedVendorBillIds: [queuedVendorBillId] },
			});
		}
	}

	handleAttemptMatch = () => {
		const { attemptMatchQueuedVendorBill, getQueuedVendorBill, showErrors } = this.props;
		const { queuedVendorBillId } = this.state;
		this.setState({ isAttemptingMatch: true });
		attemptMatchQueuedVendorBill({
			params: { queuedVendorBillId },
			callback: (err) => {
				this.setState({ isAttemptingMatch: false });
				if (err) {
					showErrors(err);
					return;
				}
				getQueuedVendorBill({
					params: { queuedVendorBillIds: [queuedVendorBillId] },
				});
			},
		});
	};

	handleHideFromQueue = () => {
		const { hideQueuedVendorBill, showErrors, history } = this.props;
		const { queuedVendorBillId } = this.state;
		hideQueuedVendorBill({
			params: { queuedVendorBillId },
			callback: (err) => {
				if (err) {
					showErrors(err);
					return;
				}
				history.push('/billing/queuedVendorBills');
			},
		});
	};

	render() {
		const { classes, queuedVendorBill, resourceMap, quickbooksItemMap, authUser } = this.props;
		const { isAttemptingMatch } = this.state;

		//- Check if data is loaded yet
		if (!queuedVendorBill) {
			return <div>Fetching bill information...</div>;
		}

		const {
			queuedVendorBillId,
			csvResourceId,
			total,
			typeOfBill,
			queueStatus,
			// supplierId,
			// quickbooksVendorId,
			dueDate,
			// quickbooksTermId,
			billDate,
			billNumber,
			//bolNumber,
			//lineItems,
			vendorBillOrders,
			errors,
			pendingReason,
			createdVendorBillId,
		} = queuedVendorBill;

		let csvResource;
		if (resourceMap) {
			csvResource = resourceMap[csvResourceId];
		}

		console.log(quickbooksItemMap);

		return (
			<Grid container spacing={0}>
				<Grid item xs={12}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={8}>
							<FMPRegionHeader isTop={true} label={`Queued Vendor Bill:${queuedVendorBillId}`} />
							<Paper className={classes.paper}>
								<div style={{ fontSize: '20px', fontWeight: 700, color: '#666' }}>
									Bill / Queue Info
								</div>
								<table style={{ padding: 20 }}>
									<tbody>
										<tr>
											<td>
												<div className={classes.poLabel}>Bill Type</div>
											</td>
											<td>{typeOfBill}</td>
										</tr>
										<tr>
											<td>
												<div className={classes.poLabel}>Queue Status</div>
											</td>
											<td>{queueStatus}</td>
										</tr>
										{queueStatus === 'PENDING' && (
											<tr>
												<td>
													<div className={classes.poLabel}>Pending Reason</div>
												</td>
												<td style={{ color: '#b26b00' }}>
													{pendingReason || 'Awaiting first match attempt'}
												</td>
											</tr>
										)}

										<tr>
											<td>
												<div className={classes.poLabel}>Total</div>
											</td>
											<td>{total}</td>
										</tr>

										<tr>
											<td>
												<div className={classes.poLabel}>Due Date</div>
											</td>
											<td>{dueDate}</td>
										</tr>

										<tr>
											<td>
												<div className={classes.poLabel}>Bill Date</div>
											</td>
											<td>{billDate}</td>
										</tr>

										<tr>
											<td>
												<div className={classes.poLabel}>Bill Number</div>
											</td>
											<td>{billNumber}</td>
										</tr>
										<tr>
											<td>
												<div className={classes.poLabel}>Total</div>
											</td>
											<td>{total}</td>
										</tr>
									</tbody>
								</table>

								{vendorBillOrders.map((vendorBillOrder, i) => {
									return (
										<div key={vendorBillOrder.vendorBillOrderId} style={{ marginTop: 20 }}>
											<div style={{ fontSize: '20px', fontWeight: 700, color: '#666' }}>
												Order {i + 1}
											</div>
											<table style={{ padding: 5, paddingLeft: 20 }}>
												<tbody>
													<tr>
														<td>BOL Number</td>
														<td>{vendorBillOrder.bolNumber}</td>
													</tr>
													{vendorBillOrder.linkedRailcarId && (
														<tr>
															<td>Railcar</td>
															<td>Railcar #{vendorBillOrder.linkedRailcarId}</td>
														</tr>
													)}
												</tbody>
											</table>

											<div style={{ paddingLeft: 20 }}>
												<div
													style={{
														fontSize: '16px',
														color: '#666',
														textTransform: 'uppercase',
														fontWeight: 500,
													}}
												>
													Line Items
												</div>
												<table style={{ paddingLeft: 20 }}>
													<tbody>
														<tr style={{ backgroundColor: '#f8f8f8' }}>
															<td style={{ padding: 5 }}>Item Id</td>
															<td style={{ padding: 5 }}>Quantity</td>
															<td style={{ padding: 5 }}>Unit Price </td>
															<td style={{ padding: 5 }}>Amount</td>
														</tr>
														{vendorBillOrder.vendorBillOrderLineItems.map((lineItem) => {
															const { quickbooksItemId, quantity, unitPrice, amount } = lineItem;

															let itemDescription = 'Missing QB Item';
															let itemName = 'Missing QB Item';
															if (quickbooksItemMap && quickbooksItemMap[quickbooksItemId]) {
																itemDescription = quickbooksItemMap[quickbooksItemId].Description;
																itemName = quickbooksItemMap[quickbooksItemId].Name;
															}

															return (
																<tr key={quickbooksItemId}>
																	<td style={{ paddingLeft: 10 }}>
																		{itemDescription} ({itemName} / {quickbooksItemId})
																	</td>
																	<td style={{ paddingLeft: 10 }}>{quantity}</td>
																	<td style={{ paddingLeft: 10 }}>{unitPrice}</td>
																	<td style={{ paddingLeft: 10 }}>{amount}</td>
																</tr>
															);
														})}
													</tbody>
												</table>
											</div>
										</div>
									);
								})}

								<br />
								{errors && errors.join(' ')}
								<br />
								{createdVendorBillId}
								<br />
							</Paper>
						</Grid>
						<Grid item xs={12} sm={4}>
							<FMPRegionHeader isTop={true} label={`CSV Document`} />
							<Paper
								className={classes.paper}
								style={{ position: 'sticky', top: 10, height: '50vh' }}
							>
								<Fragment>
									{csvResource && (
										<object
											data={csvResource.url}
											style={{ height: '100%', width: '100%', maxWidth: '100%' }}
											type={csvResource.contentType}
										>
											<div style={{ textAlign: 'center' }}>
												<p style={{ fontSize: '40px', fontWeight: 900, color: '#999' }}>CSV File</p>
												This bill was imported automatically from LF (Formerly NCP) / PDI FTP.
												<br />
												<br />
												Click this <a href={csvResource.url}>link</a> to download the CSV file if
												you want to inspect its contents.
											</div>
										</object>
									)}
								</Fragment>
							</Paper>
							<div style={{ marginTop: 8 }}>
								<Button
									variant="contained"
									color="primary"
									size="small"
									disabled={isAttemptingMatch}
									onClick={this.handleAttemptMatch}
								>
									{isAttemptingMatch ? 'Attempting Match...' : 'Attempt Match'}
								</Button>
							</div>
							{authUser && authUser.userId === 14 && (
								<div style={{ marginTop: 8 }}>
									<Button
										variant="outlined"
										color="secondary"
										size="small"
										onClick={this.handleHideFromQueue}
									>
										Remove from Queue (Re-upload)
									</Button>
								</div>
							)}
						</Grid>
					</Grid>

					{/*
					<ConfirmInvalidateVendorBillDialog
						open={this.state.isConfirmInvalidateOpen}
						onClose={this.closeInvalidateDialog}
						vendorBill={vendorBill}
						invalidateVendorBill={this.props.invalidateVendorBill}
						showErrors={this.props.showErrors}
						history={this.props.history}
					/>
									*/}
				</Grid>
			</Grid>
		);
	}
}

QueuedVendorBillView.propTypes = {
	//- me
	getQueuedVendorBill: PropTypes.func.isRequired,
	hideQueuedVendorBill: PropTypes.func.isRequired,
	attemptMatchQueuedVendorBill: PropTypes.func.isRequired,
	// invalidateVendorBill: PropTypes.func.isRequired,
	queuedVendorBill: PropTypes.object,
	resourceMap: PropTypes.object,
	authUser: PropTypes.object,

	//- misc
	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	QueuedVendorBillContainer,
])(QueuedVendorBillView);
